import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {FormControl} from "@angular/forms";
import {controlValues} from "angular-control-values";
import {ObserveInput} from "angular-observable";
import {Observable, ReplaySubject} from "rxjs";
import {RecommendedUpdateOptions, UpdateOption, UpdateOptionsWithSelection} from "./update-options";

@Component({
	selector: "select-regions",
	template: `
		<section *ngFor="let regionOptions of regionOptionsRequiringSelection | async; let i=index"
				 class="updatedatabases_section">
			<h2>Which {{regionOptions.avdbType.name}} Database?</h2>

			<div>
				<ul class="updatedatabases_options">
					<li *ngFor="let option of regionOptions.recommendedOptions">
						<label>
							<div class="updatedatabases_options_control">
								<input type="radio" name="regions-{{i}}" [formControl]="regionOptions.regionControl" [value]="option" />
							</div>
							{{option.series.region.name}}<span *ngIf="option.series.region.vendorName && option.series.region.vendorName !== ''"> by {{option.series.region.vendorName}}</span>
						</label>

						<div *ngIf="option.series.messages.length" class="updatedatabases_options_info">
							<avdb-message
								*ngFor="let message of option.series.messages"
								[message]="message">
							</avdb-message>
						</div>
					</li>
				</ul>
			</div>
		</section>

		<coverage-detail #coverageModal></coverage-detail>
	`,
})
export class SelectRegionsComponent implements OnInit {
	@ObserveInput() cycleSelection = new ReplaySubject<Array<RecommendedUpdateOptions>>(1);
	@Output() regionSelectionsChange = new EventEmitter<Array<UpdateOptionsWithSelection>>();

	regionOptions = this.cycleSelection
		.map(optionsForTypes => {
			return optionsForTypes
				.map(optionsForType => {
					if (optionsForType.recommendedOptions.length < 2) {
						return {
							...optionsForType,
							regionControl: null,
							selection: Observable.of(optionsForType.recommendedOptions[0]),
						};
					}
					else {
						let regionControl = new FormControl();
						let selection = controlValues<UpdateOption>(regionControl);
						return {
							...optionsForType,
							regionControl,
							selection,
						};
					}
				});
		})
		.publishReplay(1)
		.refCount();

	regionOptionsRequiringSelection = this.regionOptions
		.map(optionsForTypes => {
			return optionsForTypes.filter(optionsForType => optionsForType.regionControl != null);
		});

	regionSelections = this.regionOptions
		.switchMap(optionsForTypes => {
			let selections = optionsForTypes
				.map(optionsForType => {
					return optionsForType.selection
						.map(selection => {
							let options: UpdateOptionsWithSelection = {
								avdbType: optionsForType.avdbType,
								allOptions: optionsForType.allOptions,
								recommendedOptions: optionsForType.recommendedOptions,
								needsReinstall: optionsForType.needsReinstall,
								selection,
							};
							return options;
						});
				});

			return Observable.combineLatest(...selections)
				.map(optionsForTypes => {
					if (optionsForTypes.some(o => o.selection == null && o.recommendedOptions.length > 0))
						return null;
					return optionsForTypes;
				});
		});

	ngOnInit() {
		this.regionSelections.subscribe(this.regionSelectionsChange);
	}
}
